import styled, { css } from 'styled-components';

export const Wrapper = styled.span<{ $disabled?: boolean }>(
  ({ theme: { admanColors }, $disabled }) => css`
    font-family: InspireTWDC;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: ${admanColors!.blue.dark.bg1[0]};
    cursor: ${$disabled ? 'not-allowed' : 'pointer'};
  `
);
